import type { AddonFilterConfig, ValidationResult } from './schema.ts';

export function validateConfig(config: AddonFilterConfig): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];

  if (!config.activeTicketGroupId) {
    errors.push('Missing activeTicketGroupId.');
  }
  if (Object.keys(config.activeTicketAddonMap).length === 0) {
    errors.push('activeTicketAddonMap is empty (no tickets mapped).');
  }
  if (Object.keys(config.addonCategoryById).length === 0) {
    errors.push('addonCategoryById is empty (no groups mapped to addons).');
  }

  const categoryKeys = Object.keys(config.addonCategoryLabels);
  const knownCats = new Set(categoryKeys);

  for (const ticketId of Object.keys(config.activeTicketAddonMap)) {
    const addons = config.activeTicketAddonMap[ticketId] || [];
    if (addons.length === 0) {
      warnings.push(`Ticket ${ticketId} has no addons mapped.`);
    }
    for (const addonId of addons) {
      const cat = config.addonCategoryById[String(addonId)];
      if (!cat) {
        errors.push(`Addon ${addonId} (used by ticket ${ticketId}) has no group assigned.`);
      } else if (!knownCats.has(cat)) {
        errors.push(`Addon ${addonId} uses unknown group "${cat}".`);
      }
    }
  }

  const usedAddonIds = new Set(
    Object.values(config.activeTicketAddonMap).flat().map(String)
  );
  for (const addonId of Object.keys(config.addonCategoryById)) {
    if (!usedAddonIds.has(String(addonId))) {
      warnings.push(`Addon ${addonId} has a group but is not used by any ticket.`);
    }
  }

  for (const key of config.defaultOpenCategories) {
    if (!knownCats.has(key)) {
      errors.push(`Default open group "${key}" is not defined in groups.`);
    }
  }

  return { errors, warnings };
}
